import * as XLSX from "xlsx";
import Modal from "react-modal";
import "./ClientsInvoices.css";
import { DatePicker } from "rsuite";
import moment from "moment-timezone";
import subDays from "date-fns/subDays";
import { toast } from "react-toastify";
import { Column } from "primereact/column";
import "react-toastify/dist/ReactToastify.css";
import { DataTable } from "primereact/datatable";
import isEqual from "lodash/isEqual";
import ClientsInvoicesModal from "./elements/clientsInvoicesModal";
import { useSelector, useDispatch } from "react-redux";
import { renderClientsInvoicesCTA } from "../../../helpers/invoiceHelpers";
import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import invStatusConsts from "../../../constants/invStatusConsts";
import InvoiceImage from "../../../images/icons/invoice-icon-1.svg";
import DownloadImage from "../../../images/icons/download-icon.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import payStatusConsts from "../../../constants/invPaymetStatusConsts";
import { createDateCliInvConvert, dateCliInvConvert } from "../../../helpers/dateHelper";
import { setHeaderText } from "../../../features/headerText/headerTextSlice";
import { setSideBarText } from '../../../features/sideBarText/sideBarTextSlice.js';
import { useGetTeams } from "../../TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import { setAppLoading } from "../../../features/appSettings/appSettingsSlice.js";
import { useGetClients } from "../../TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import TruncateFilterFieldView from "../../helpers/truncateFilterFieldView.js";
import { useFetchClientsInvoices } from "../ClientInvoice/useClientInvoice.jsx";
import MemberName from "../../Dashboard/elements/memberName.jsx";
import cliInvPaymStatus from "../../../constants/cliInvPaymStatus.js";
import cliInvStatusConsts from "../../../constants/cliInvStatusConsts.js";
import cliInvoiceStatus from "../../../constants/cliInvoiceStatus.js";
import userCategory from "../../../constants/userCategory.js";
import DateConverter from "../../helpers/dateFormatChange.js";
import { ClientInvoiceTableSkeleton } from "./ClientInvoiceTableSkeleton";
import CalendarIcon from '../../ui/CalendarIcon';

const useRenderMemberName = (rowData) => {
  const [showFullname, setShowFullname] = useState(false);
  const clientName =
    (rowData.cli_inv_for.client_name || rowData.cli_inv_for.legal_entity_name);
  const displayName = showFullname
    ? clientName
    : clientName.length <= 15
      ? clientName
      : clientName.slice(0, 15) + "...";

  return (
    <div
      className={`member-name-client member-name${showFullname ? " active" : ""}`}
      onMouseEnter={() => {
        if (clientName.length > 15) {
          setShowFullname(true);
        }
      }}
      onMouseLeave={() => setShowFullname(false)}
    >
      <span>{displayName}</span>
    </div>
  );
};


const ranges = [
  {
    label: "today",
    value: new Date(), // Use a single date instead of an array
  },
  {
    label: "yesterday",
    value: subDays(new Date(), 1),
  },
];

const ClientsInvoices = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  // const [isLoading, setIsLoading] = useState(true);
  const [clientsFilter, setClientsFilter] = useState("All");
  const [selectAllClient, setSelectAllClient] = useState(true);
  const [selectedClients, setSelectedClients] = useState([]);
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const [isClientModalDropdownOpen, setIsClientModalDropdownOpen] = useState(false);
  const [clientDropdownSearchTerm, setClientDropdownSearchTerm] = useState('');
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [invoiceNumberRaw, setInvoiceNumberRaw] = useState("");
  const [invoiceNumberFilter, setInvoiceNumberFilter] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [invStatusList, setInvStatusList] = useState([]);
  const [invPaymStatusList, setInvPaymStatusList] = useState([]);
  const [invoiceTypeModalIsOpen, setInvoiceTypeModalIsOpen] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectAllStatus, setSelectAllStatus] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isStatusModalDropdownOpen, setIsStatusModalDropdownOpen] = useState(false);
  const [selectAllPaymentStatus, setSelectAllPaymentStatus] = useState(true);
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([]);
  const [isPaymentStatusDropdownOpen, setIsPaymentStatusDropdownOpen] = useState(false);
  const [isPaymentStatusModalDropdownOpen, setIsPaymentStatusModalDropdownOpen] = useState(false);
  const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
  const teamDropdownRef = useRef(null);
  const paymentStatusDropdownRef = useRef(null);
  const paymentStatusModalDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const statusModalDropdownRef = useRef(null);
  const showingDropdownRef = useRef(null);
  const clientDropdownRef = useRef(null);
  const clientModalDropdownRef = useRef(null);
  const [sec3] = useState(100);
  const invoiceNumberDebounceRef = useRef(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectAllTeam, setSelectAllTeam] = useState([]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setCurrentPage(0);
  };
  // const [products, setProducts] = useState([]);
  let token = null;
  const { user } = useSelector((state) => state.auth);
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }
  const { data: teams = [] } = useGetTeams(token);
  const { 
    data: clientInvoiceData = { data: [], total: 0 }, 
    isLoading, 
    isFetching
  } = useFetchClientsInvoices({
    token,
    page: currentPage + 1, // Backend uses 1-based pagination
    limit: rowsPerPage,
    invoiceNumber: invoiceNumberFilter.trim(),
    status: statusFilter === "All" ? "All" : statusFilter,
    paymentStatus: paymentStatusFilter === "All" ? "All" : paymentStatusFilter,
    dueDate: selectedDate ? selectedDate.toISOString() : null,
    clients: clientsFilter === "All" ? "All" : clientsFilter,
  });
  const { data: clients = [], isLoading: clientLoading } = useGetClients(token);

  const clientInvoiceList = clientInvoiceData.data || [];
  const totalResults = clientInvoiceData.total || 0;

  useEffect(() => {
    const handleLoading = async () => {
      await dispatch(setAppLoading(clientLoading));
    };
    handleLoading();
  }, [clientLoading, dispatch]);

  useEffect(() => {
    // Filter the status list based on user category
    const filteredStatusList =
      user.userCategory === userCategory.Client
        ? cliInvoiceStatus.cli_inv_status.filter(status => status.status !== "Pending")
        : cliInvoiceStatus.cli_inv_status;

    // Set status lists
    setInvStatusList(filteredStatusList);
    setInvPaymStatusList(cliInvPaymStatus.cli_inv_paym_status);

    // Set header text based on user category
    if (user && user.userCategory === userCategory.Client) {
      dispatch(setHeaderText("Invoices"));
    } else {
      dispatch(setHeaderText("Client Invoices"));
    }

    // Set sidebar text
    dispatch(setSideBarText(""));
  }, [dispatch, user]);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(0);
  }, [invoiceNumberFilter, statusFilter, paymentStatusFilter, selectedDate, clientsFilter, rowsPerPage]);

  // Use server-side paginated data directly
  const filteredData = clientInvoiceList;
  const renderAmount = (rowData) => {
    var totalAmount = rowData.cli_inv_total_amount.toLocaleString("en-US", {
      style: "currency",
      currency: rowData.cli_inv_currency,
    });

    return <span> {totalAmount}</span>;
  };


  const handleCheckboxClientChange = (clientId) => {
    const updatedSelection = [...selectedClients];
    const index = updatedSelection.indexOf(clientId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(clientId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }
    setSelectedClients(updatedSelection);
  };

  const handleSelectAllClientChange = () => {
    if (!selectAllClient) {
      const allClientIds = clients.map(client => client._id);
      setSelectedClients(allClientIds);
    } else {
      setSelectedClients([]);
    }
    setSelectAllClient(!selectAllClient);
  };

  const initializedRef = useRef(false);

  const filteredDropdownClients = clients.filter((client) => {
    const clientName = client?.client_name || client?.legal_entity_name;
    return clientName?.toLowerCase().includes(clientDropdownSearchTerm?.toLowerCase());
  });

  const handleClientDropdownSearchChange = (e) => {
    setClientDropdownSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (!initializedRef.current || clients.length === 0) return;
    const allSelected = selectedClients.length === clients.length;
    setSelectAllClient(allSelected);
    setClientsFilter(allSelected ? "All" : selectedClients);
  }, [selectedClients, clients]);

  const toggleClientDropdown = () => {
    setIsClientDropdownOpen(!isClientDropdownOpen);
    setClientDropdownSearchTerm("");
  };

  const toggleClientModalDropdown = () => {
    setIsClientModalDropdownOpen(!isClientModalDropdownOpen);
    setClientDropdownSearchTerm("");
  };

  const handleCheckboxStatusChange = (statusId) => {
    const updatedSelection = [...selectedStatus];
    const index = updatedSelection.indexOf(statusId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(statusId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }
    setCurrentPage(0);
    setSelectedStatus(updatedSelection);
  };

  const handleSelectAllStatusChange = () => {
    if (!selectAllStatus) {
      setSelectedStatus(invStatusList.map((status) => status._id));
    } else {
      setSelectedStatus([]);
    }
    setSelectAllStatus(!selectAllStatus);
  };

  useEffect(() => {
    if (!initializedRef.current || invStatusList.length === 0) return;
    const allSelected = selectedStatus.length === invStatusList.length;
    setSelectAllStatus(allSelected);
    setStatusFilter(allSelected ? "All" : selectedStatus);
  }, [selectedStatus, invStatusList]);

  const toggleStatusDropdown = () => {
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
  };

  const toggleStatusModalDropdown = () => {
    setIsStatusModalDropdownOpen(!isStatusModalDropdownOpen);
  };

  useEffect(() => {
    if (!initializedRef.current || invPaymStatusList.length === 0) return;
    const allSelected = selectedPaymentStatus.length === invPaymStatusList.length;
    setSelectAllPaymentStatus(allSelected);
    setPaymentStatusFilter(allSelected ? "All" : selectedPaymentStatus);
  }, [selectedPaymentStatus, invPaymStatusList]);

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideClientDropdown = clientDropdownRef.current && clientDropdownRef.current.contains(event.target);
    const isClickInsideClientModalDropdown = clientModalDropdownRef.current && clientModalDropdownRef.current.contains(event.target);
    const isClickInsidePaymentStatusDropdown = paymentStatusDropdownRef.current && paymentStatusDropdownRef.current.contains(event.target);
    const isClickInsidePaymentStatusModalDropdown = paymentStatusModalDropdownRef.current && paymentStatusModalDropdownRef.current.contains(event.target);
    const isClickInsideStatusDropdown = statusDropdownRef.current && statusDropdownRef.current.contains(event.target);
    const isClickInsideStatusModalDropdown = statusModalDropdownRef.current && statusModalDropdownRef.current.contains(event.target);
    const isClickInsideshowingDropdown = showingDropdownRef.current && showingDropdownRef.current.contains(event.target);

    if (!isClickInsideClientDropdown) {
      setIsClientDropdownOpen(false);
    }
    if (!isClickInsideClientModalDropdown) {
      setIsClientModalDropdownOpen(false);
    }
    if (!isClickInsideStatusDropdown) {
      setIsStatusDropdownOpen(false);
    }
    if (!isClickInsideStatusModalDropdown) {
      setIsStatusModalDropdownOpen(false);
    }
    if (!isClickInsidePaymentStatusDropdown) {
      setIsPaymentStatusDropdownOpen(false);
    }
    if (!isClickInsidePaymentStatusModalDropdown) {
      setIsPaymentStatusModalDropdownOpen(false);
    }
    if (!isClickInsideshowingDropdown) {
      setShowingDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideDropdown);

    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, []);

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const clearFilters = () => {
    setInvoiceNumberRaw("");
    setInvoiceNumberFilter("");
    // setClientFilter("");
    setSelectedTeams(teams.map((team) => team._id));
    setSelectedClients(clients.map((client) => client._id));
    setSelectedStatus(invStatusList.map((status) => status._id));
    setSelectedPaymentStatus(
      invPaymStatusList.map((paymentstatus) => paymentstatus._id)
    );
    setSelectedDate(null);
    setShowFilterModal(false);
  };

  const checkAndShowConfirmationModal = () => {
    // const isCliNameModified = !isEqual(clientFilter, "");
    const isClientsModified = !isEqual(selectedClients, clients.map((client) => client._id));
    const isInvNumModified = !isEqual(invoiceNumberFilter, "");
    const isStatusModified = !isEqual(selectedStatus, invStatusList.map((status) => status._id));
    const isPaymentStatusModified = !isEqual(selectedPaymentStatus, invPaymStatusList.map((paymentstatus) => paymentstatus._id));
    const isDueDateModified = !isEqual(selectedDate, null);

    if (
      isClientsModified ||
      isInvNumModified ||
      isStatusModified ||
      isPaymentStatusModified ||
      isDueDateModified
    ) {
      setShowConfirmationModal(true);
    } else {
      setShowFilterModal(false);
    }
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
  };

  const handleApplyConfirm = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(false);
  };

  const toggleFilterModal = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(!showFilterModal);
  };

  useEffect(() => {
    if (
      initializedRef.current ||
      teams.length === 0 ||
      clients.length === 0 ||
      invStatusList.length === 0 ||
      invPaymStatusList.length === 0
    ) return;
    initializedRef.current = true;
    setSelectedTeams(teams.map((t) => t._id));
    setSelectedClients(clients.map((c) => c._id));
    setSelectedStatus(invStatusList.map((s) => s._id));
    setSelectedPaymentStatus(invPaymStatusList.map((p) => p._id));
  }, [teams, clients, invStatusList, invPaymStatusList]);


  const renderStatus = (rowData) => {
    // Determine the class based on the payment_status value
    let statusClass;
    let statusName;
    if (rowData.cli_inv_status === cliInvStatusConsts.Invoice_Send) {
      const startDate = moment().tz(global.config.getTimeZone());
      const endDate = moment(rowData.cli_inv_due_date).tz(global.config.getTimeZone());
      const diffInDays = endDate.diff(startDate, "days");
      if (diffInDays < 0) {
        statusClass = "overdue";
        statusName = "Overdue";
      } else {
        statusClass = "pending";
        statusName = "Invoice Sent";
      }
    } else if (rowData.cli_inv_status === cliInvStatusConsts.Pending) {
      // statusClass = "pending";
      // statusName = "Pending";
      const startDate = moment().tz(global.config.getTimeZone());
      const endDate = moment(rowData.cli_inv_due_date).tz(global.config.getTimeZone());
      const diffInDays = endDate.diff(startDate, "days");
      if (diffInDays < 0) {
        statusClass = "overdue";
        statusName = "Overdue";
      } else {
        statusClass = "pending";
        statusName = "Pending";
      }
    } else if (rowData.cli_inv_status === cliInvStatusConsts.Rejected) {
      statusClass = "overdue";
      statusName = "Cancelled";
    } else if (rowData.cli_inv_status === cliInvStatusConsts.Cancelled) {
      statusClass = "overdue";
      statusName = "Cancelled";
    } else if (rowData.cli_inv_status === cliInvStatusConsts.Payment_Processed) {
      statusClass = "manual";
      statusName = "Payment Processed";
    }
    return (
      <span className={`payment-status ${statusClass}`}>{statusName}</span>
    );
  };

  const renderPaymentStatus = (rowData) => {
    let statusClass;
    let statusName;

    if (rowData.cli_inv_paid_date) {
      statusClass = "manual";
      statusName = <DateConverter date={rowData.cli_inv_paid_date} />;
    } else {
      statusClass = "pending";
      statusName = "Not updated";
    }

    return (
      <span className={`payment-status ${statusClass}`}>{statusName}</span>
    );
  };


  const handleAutomaticModalOpen = async () => {
    setInvoiceTypeModalIsOpen(true);
  };

  const handleModalCancel = () => {
    setInvoiceTypeModalIsOpen(false);
  };

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.error("No data to export.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    // Defer to next event loop tick so UI stays responsive
    setTimeout(() => {
    try {
      const now = new Date();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");

      const modifiedLog = [];
      filteredData.forEach((item, index) => {
        // Assuming these items in an array
        const descriptions = item.cli_inv_description;
        const costs = item.cli_inv_cost;
        const taxs = item.cli_inv_tax;

        if (descriptions && descriptions.length > 0) {
          descriptions.forEach((description, i) => {
            const cost = parseFloat(costs?.[i] ?? 0) || 0;
            const tax = parseFloat(taxs?.[i] ?? 0) || 0;
            const vat = (cost * (tax / 100)).toFixed(2);
            const amount = (cost + parseFloat(vat)).toFixed(2);
            modifiedLog.push({
              "Invoice Number": item.cli_inv_number,
              "Invoice Issue Date": moment(item.cli_inv_issue_date)
                .tz(global.config.getTimeZone())
                .format("DD/MM/YYYY"),
              "Invoice Due Date": moment(item.cli_inv_due_date)
                .tz(global.config.getTimeZone())
                .format("DD/MM/YYYY"),
              Period:
                moment(item.cli_inv_start_date)
                  .tz(global.config.getTimeZone())
                  .format("DD/MM/YYYY") +
                " - " +
                moment(item.cli_inv_end_date)
                  .tz(global.config.getTimeZone())
                  .format("DD/MM/YYYY"),
              User: (item.cli_inv_for?.client_name) || (item.cli_inv_for?.legal_entity_name) || '',
              Item: i + 1,
              Description: description,
              Cost: costs[i],
              "VAT(%)": taxs[i],
              VAT: (costs[i] * (taxs[i] / 100)).toFixed(2),
              Amount: amount,
              "Invoice Currency": item.cli_inv_currency,
              "Invoice Payment Date & Time": item.cli_inv_paid_date
                ? moment(item.cli_inv_paid_date)
                  .tz(global.config.getTimeZone())
                  .format("DD/MM/YYYY, hh:mm:ss A")
                : "Not Updated",
              "Created At": moment(item.cli_inv_created_at)
                .tz(global.config.getTimeZone())
                .format("DD/MM/YYYY, hh:mm:ss A"),
            });
          });
        } else {
          modifiedLog.push({
            "Invoice Number": item.cli_inv_number,
            "Invoice Issue Date": moment(item.cli_inv_issue_date)
              .tz(global.config.getTimeZone())
              .format("DD/MM/YYYY"),
            "Invoice Due Date": moment(item.cli_inv_due_date)
              .tz(global.config.getTimeZone())
              .format("DD/MM/YYYY"),
            Period:
              moment(item.cli_inv_start_date)
                .tz(global.config.getTimeZone())
                .format("DD/MM/YYYY") +
              " - " +
              moment(item.cli_inv_end_date)
                .tz(global.config.getTimeZone())
                .format("DD/MM/YYYY"),
            User: (item.cli_inv_for?.client_name) || (item.cli_inv_for?.legal_entity_name) || '',
            Item: 1,
            Description: "", // Set empty description for single row
            Cost: "",
            "VAT(%)": "",
            Amount: "",
            "Invoice Currency": item.cli_inv_currency,
            "Invoice Payment Date & Time": item.cli_inv_paid_date
              ? moment(item.cli_inv_paid_date)
                .tz(global.config.getTimeZone())
                .format("DD/MM/YYYY, hh:mm:ss A")
              : "Not Updated",

            "Created At": moment(item.cli_inv_created_at)
              .tz(global.config.getTimeZone())
              .format("DD/MM/YYYY, hh:mm:ss A"),
          });
        }
      });

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(modifiedLog);
      const colWidths = [
        { wpx: 80 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 125 },
        { wpx: 125 },
        { wpx: 35 },
        { wpx: 200 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 175 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 150 },
      ];
      worksheet["!cols"] = colWidths;
      // Add alignment to center align the first row and increase font size
      const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
      for (let i = 0; i < colWidths.length; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        const style = worksheet[cell]?.s || {};
        style.alignment = style.alignment || {};
        style.alignment.horizontal = "center !important";
        style.alignment.vertical = "center !important";
        style.font = { size: 14, bold: true };
        worksheet[cell] = { ...worksheet[cell], s: style };
      }

      // Set border for active area and increase font size
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          const style = worksheet[cell]?.s || {};
          style.font = { size: 12 };
          worksheet[cell] = { ...worksheet[cell], s: style };
        }
      }
      global.config.activityLog(
        window.location.href,
        "Invoice",
        "Invoices List exported to Excel"
      );
      const fileName = `Invoice_Report_${formattedDate}_${formattedTime}.xlsx`;
      worksheet["!autofilter"] = { ref: range };
      XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice Report");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      global.config.activityLog(
        window.location.href,
        "Invoice",
        "Error occurred while exporting INVOICES to Excel"
      );
      toast.error("Error occurred while exporting to Excel.", { position: "bottom-right", autoClose: 2000 });
    }
    }, 0);
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0); // Set the current page to 0 when changing rows per page
  };

  const onPageChange = (e) => {
    setCurrentPage(e.page);
  };

  return (
    <div className="outer-invoice-clinet-section">
      <div className="invoice-outer-invoice">
        <div className="invoice-top">
          <div className="new-top-flter">
            <div className="button-sec-invoice">
              {(user && (user.userCategory !== userCategory.Client)) && (
                <>
                  <button onClick={handleAutomaticModalOpen} className="btn-forpop-initem">
                    <span className="icon-invoice">
                      <img src={InvoiceImage} alt="Create Invoice" />
                    </span>
                    Create Invoice
                  </button>
                  <Modal
                    isOpen={invoiceTypeModalIsOpen}
                    onRequestClose={handleModalCancel}
                    contentLabel="Invoice Type"
                    style={{
                      content: {
                        width: "50%",
                        maxWidth: "500px",
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        height: "auto",
                      },
                    }}
                  >
                    <div className="modal">
                      <div className="outter-modal-main">
                        <button
                          className="close-image-clr1"
                          onClick={() => {
                            setInvoiceTypeModalIsOpen(false);
                          }}
                          aria-label="Close modal"
                        >
                          <img src={crssrImage} alt="Close Icon" />{" "}
                        </button>
                      </div>
                      <ClientsInvoicesModal />
                    </div>
                  </Modal>
                </>
              )}
              {/* invoice type madal end */}
              <button onClick={exportToExcel} className="btn-forpop-initem">
                <span className="icon-invoice">
                  <img src={DownloadImage} alt="Export" />
                </span>
                Export Data
              </button>
            </div>
            <div className="filter-invoice-right">
              <div className="filter-inner showing-result">
                <label>Showing</label>
                <div
                  ref={showingDropdownRef}
                  className="select-modal-mainM custom-dropdown-user-new-outer"
                >
                  <div
                    className="selected-option custom-dropdown-user-new"
                    onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}
                  >
                    {totalResults < 10
                      ? totalResults.toString()
                      : rowsPerPage.toString()}
                  </div>
                  {showingDropdownOpen && (
                    <div className="custom-dropdown-new">
                      <ul className="showing-options-list">
                        {totalResults >= 10 && (
                          <li
                            className={rowsPerPage === 10 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: 10 } });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            10
                          </li>
                        )}
                        {totalResults >= 20 && (
                          <li
                            className={rowsPerPage === 20 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: 20 } });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            20
                          </li>
                        )}
                        {totalResults >= 30 && (
                          <li
                            className={rowsPerPage === 30 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: 30 } });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            30
                          </li>
                        )}
                        {totalResults >= 40 && (
                          <li
                            className={rowsPerPage === 40 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({ target: { value: 40 } });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            40
                          </li>
                        )}
                        {totalResults > 10 && (
                          <li
                            className={
                              totalResults > 10 && rowsPerPage === totalResults
                                ? "selected-item"
                                : ""
                            }
                            onClick={() => {
                              handleRowsPerPageChange({
                                target: { value: totalResults },
                              });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            ALL
                          </li>
                        )}
                        {totalResults < 10 ? (
                          <li
                            className={totalResults < 10 ? "selected-item" : ""}
                            onClick={() => {
                              handleRowsPerPageChange({
                                target: { value: totalResults },
                              });
                              setShowingDropdownOpen(false);
                            }}
                          >
                            {totalResults}
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  )}
                </div>
                <label>of {totalResults} Results</label>
              </div>
            </div>
          </div>

          <div className="invoice-filter">
            <div className="invoice-filter-inner-section no-flter-all">
              <div className="filter-inner invoice-id">
                <label htmlFor="fname">Invoice ID</label>
                <input
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    setInvoiceNumberRaw(val);
                    clearTimeout(invoiceNumberDebounceRef.current);
                    invoiceNumberDebounceRef.current = setTimeout(() => {
                      setInvoiceNumberFilter(val);
                      setCurrentPage(0);
                    }, 350);
                  }}
                  value={invoiceNumberRaw}
                  id="invoiceId"
                  name="invoiceId"
                  placeholder="All"
                />
              </div>
              {(user && (user.userCategory !== userCategory.Client)) && (
                <div className="filter-inner users">
                  <label htmlFor="fname">Client</label>
                 
                  <div className="custom-dropdown1" ref={clientDropdownRef}>
                    <div className="drop-down-inner">
                      <div className="selected-options1" onClick={toggleClientDropdown}>
                        {clients.length === 0 || selectAllClient ? (
                          <div className="selected-option1">All</div>
                        ) : selectedClients.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div className="selected-option1" key={selectedClients[0]}>
                              {selectedClients.length === clients.length
                                ? 'All'
                                : (
                                  <>
                                    <TruncateFilterFieldView textContent={clients.find((item) => item._id === selectedClients[0])?.client_name} />
                                    {selectedClients.length > 1 && selectedClients.length !== clients.length && (
                                      <div className="selected-option-count">
                                        {selectedClients.length - 1}+
                                      </div>
                                    )}
                                  </>
                                )}
                            </div>
                          </>
                        )}
                      </div>
                      {isClientDropdownOpen && (
                        <div className="dropdown-list1">
                          <input
                            type="text"
                            placeholder="Search clients"
                            value={clientDropdownSearchTerm}
                            onChange={handleClientDropdownSearchChange}
                            className="search-bar"
                          />
                          {filteredDropdownClients.length > 0 && (
                            <>
                              {clientDropdownSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllClient}
                                    onChange={handleSelectAllClientChange}
                                  />
                                  All
                                </label>
                              )}
                              {filteredDropdownClients
                                .slice()
                                .sort((a, b) =>
                                  a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
                                )
                                .map((client) => (
                                  <label className="checkbox-label1" key={client._id}>
                                    <input
                                      type="checkbox"
                                      checked={selectedClients.includes(client._id)}
                                      onChange={() => handleCheckboxClientChange(client._id)}
                                    />
                                    {client.client_name && `${client.client_name}`}
                                  </label>
                                ))}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="filter-inner invoice-status">
                <label htmlFor="invoiceStatus">Invoice Status</label>
                <div className="custom-dropdown1" ref={statusDropdownRef}>
                  <div className="drop-down-inner">
                    <div
                      className="selected-options1"
                      onClick={toggleStatusDropdown}
                    >
                      {invStatusList.length === 0 || selectAllStatus ? (
                        <div className="selected-option1">All</div>
                      ) : selectedStatus.length === 0 ? (
                        <div className="placeholder">Select</div>
                      ) : (
                        <>
                          <div
                            className="selected-option1"
                            key={selectedStatus[0]}
                          >
                            {selectedStatus.length === invStatusList.length ? (
                              "All"
                            ) : (
                              <>
                                <TruncateFilterFieldView
                                  textContent={
                                    invStatusList.find(
                                      (item) => item._id === selectedStatus[0]
                                    )?.status
                                  }
                                />
                                {selectedStatus.length > 1 &&
                                  selectedStatus.length !==
                                  invStatusList.length && (
                                    <div className="selected-option-count">
                                      {selectedStatus.length - 1}+
                                    </div>
                                  )}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                    {isStatusDropdownOpen && (
                      <div className="dropdown-list1">
                        {invStatusList.length > 0 && (
                          <>
                            <label className="checkbox-label1" key="selectAll">
                              <input
                                type="checkbox"
                                checked={selectAllStatus}
                                onChange={handleSelectAllStatusChange}
                              />
                              All
                            </label>
                            {invStatusList.map((status) => (
                              <label className="checkbox-label1" key={status._id}>
                                <input
                                  type="checkbox"
                                  checked={selectedStatus.includes(status._id)}
                                  onChange={() =>
                                    handleCheckboxStatusChange(status._id)
                                  }
                                />
                                {status.status && `${status.status}`}
                              </label>
                            ))}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
             
              <div className="filter-inner due-date">
                <label htmlFor="dueDate" className="calendar-icon">
                  Due Date
                </label>
                <div className="date-picker-outer date-picker-outer-all">
                  <div className="custoom-icon-calender custoom-icon-calender-all">
                    <DatePicker
                      oneTap // Use DatePicker instead of DateRangePicker
                      format="dd/MM/yyyy"
                      ranges={ranges}
                      value={selectedDate}
                      onChange={handleDateChange}
                      placement="auto"
                      className="invoice-filter-top-date"
              caretAs={CalendarIcon}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-invoice-right apply-fliter-right">
              <button onClick={toggleFilterModal}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="17"
                  viewBox="0 0 13 17"
                  fill="none"
                >
                  <path
                    d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z"
                    fill="#6479F8"
                  />
                  <path
                    d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z"
                    fill="#6479F8"
                  />
                  <path
                    d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z"
                    fill="#6479F8"
                  />
                </svg>
                All Filters
              </button>
            </div>
            <Modal
              isOpen={showFilterModal}
              onRequestClose={toggleFilterModal}
              contentLabel="Filter Modal"
              className="new-filter-modal"
              style={{
                content: {
                  height: "50%",
                  width: "50%",
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  borderRadius: "10px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#fff",
                  padding: "20px",
                  // overflow: "auto",
                },
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                },
              }}
            >
              <div className="new-nodal-invoice-outer-sec">
                <div className="new-modal-top-sec">
                  <div className="new-modal-heading">
                    All filters
                  </div>
                  <button className="close-image-clr1" onClick={checkAndShowConfirmationModal} aria-label="Close modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M1 13L13 1" stroke="black" />
                      <path d="M1 0.999999L13 13" stroke="black" />
                    </svg>{" "}
                  </button>
                </div>
                <div className="invoice-filter-inner-section">
                  <div className="filter-inner invoice-id">
                    <label htmlFor="fname">Invoice ID</label>
                    <input
                      type="text"
                      onChange={(e) => {
                        const val = e.target.value;
                        setInvoiceNumberRaw(val);
                        clearTimeout(invoiceNumberDebounceRef.current);
                        invoiceNumberDebounceRef.current = setTimeout(() => {
                          setInvoiceNumberFilter(val);
                          setCurrentPage(0);
                        }, 350);
                      }}
                      value={invoiceNumberRaw}
                      id="invoiceId"
                      name="invoiceId"
                      placeholder="All"
                    />
                  </div>

                  {(user && (user.userCategory !== userCategory.Client)) && (
                    <div className="filter-inner invoice-id">
                      <label htmlFor="fname">Client</label>
                     
                      <div className="custom-dropdown1" ref={clientModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div className="selected-options1" onClick={toggleClientModalDropdown}>
                            {clients.length === 0 || selectAllClient ? (
                              <div className="selected-option1">All</div>
                            ) : selectedClients.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div className="selected-option1" key={selectedClients[0]}>
                                  {selectedClients.length === clients.length
                                    ? 'All'
                                    : (
                                      <>
                                        <TruncateFilterFieldView textContent={clients.find((item) => item._id === selectedClients[0])?.client_name} />
                                        {selectedClients.length > 1 && selectedClients.length !== clients.length && (
                                          <div className="selected-option-count">
                                            {selectedClients.length - 1}+
                                          </div>
                                        )}
                                      </>
                                    )}
                                </div>
                              </>
                            )}
                          </div>
                          {isClientModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search clients"
                                value={clientDropdownSearchTerm}
                                onChange={handleClientDropdownSearchChange}
                                className="search-bar"
                              />
                              {filteredDropdownClients.length > 0 && (
                                <>
                                  {clientDropdownSearchTerm === "" && (
                                    <label className="checkbox-label1" key="selectAll">
                                      <input
                                        type="checkbox"
                                        checked={selectAllClient}
                                        onChange={handleSelectAllClientChange}
                                      />
                                      All
                                    </label>
                                  )}
                                  {filteredDropdownClients
                                    .slice()
                                    .sort((a, b) =>
                                      a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
                                    )
                                    .map((client) => (
                                      <label className="checkbox-label1" key={client._id}>
                                        <input
                                          type="checkbox"
                                          checked={selectedClients.includes(client._id)}
                                          onChange={() => handleCheckboxClientChange(client._id)}
                                        />
                                        {client.client_name && `${client.client_name}`}
                                      </label>
                                    ))}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="filter-inner invoice-status">
                    <label htmlFor="invoiceStatus">Invoice Status</label>
                    <div className="custom-dropdown1" ref={statusModalDropdownRef}>
                      <div className="drop-down-inner">
                        <div
                          className="selected-options1"
                          onClick={toggleStatusModalDropdown}
                        >
                          {invStatusList.length === 0 || selectAllStatus ? (
                            <div className="selected-option1">All</div>
                          ) : selectedStatus.length === 0 ? (
                            <div className="placeholder">Select</div>
                          ) : (
                            <>
                              <div
                                className="selected-option1"
                                key={selectedStatus[0]}
                              >
                                {selectedStatus.length ===
                                  invStatusList.length ? (
                                  "All"
                                ) : (
                                  <>
                                    <TruncateFilterFieldView
                                      textContent={
                                        invStatusList.find(
                                          (item) => item._id === selectedStatus[0]
                                        )?.status
                                      }
                                    />
                                    {selectedStatus.length > 1 &&
                                      selectedStatus.length !==
                                      invStatusList.length && (
                                        <div className="selected-option-count">
                                          {selectedStatus.length - 1}+
                                        </div>
                                      )}
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        {isStatusModalDropdownOpen && (
                          <div className="dropdown-list1">
                            {invStatusList.length > 0 && (
                              <>
                                <label
                                  className="checkbox-label1"
                                  key="selectAll"
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectAllStatus}
                                    onChange={handleSelectAllStatusChange}
                                  />
                                  All
                                </label>
                                {invStatusList.map((status) => (
                                  <label
                                    className="checkbox-label1"
                                    key={status._id}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedStatus.includes(
                                        status._id
                                      )}
                                      onChange={() =>
                                        handleCheckboxStatusChange(status._id)
                                      }
                                    />
                                    {status.status && `${status.status}`}
                                  </label>
                                ))}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                 
                  <div className="filter-inner due-date">
                    <label htmlFor="dueDate" className="calendar-icon">
                      Due Date
                    </label>
                    <div className="date-picker-outer date-picker-outer-all">
                      <div className="custoom-icon-calender custoom-icon-calender-all">
                        <DatePicker
                          oneTap // Use DatePicker instead of DateRangePicker
                          format="dd/MM/yyyy"
                          ranges={ranges}
                          value={selectedDate}
                          onChange={handleDateChange}
                          placement="auto"
                          className="invoice-filter-top-date"
              caretAs={CalendarIcon}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Modal
                className="delete-modal"
                isOpen={showConfirmationModal}
                onRequestClose={handleCancel}
                contentLabel="Confirm Delete"
                style={{
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "36%",
                    left: "50%",
                  },
                }}
              >
                <div className="delete-modal-content">
                  <h2>Apply or Discard changes?</h2>
                  <p>
                    Do you want to Apply or Discard filter changes?
                  </p>

                  <div className="delete-modal-buttons">
                    <button className="delete" onClick={handleApplyConfirm} >
                      Apply Changes
                    </button>
                    <button onClick={clearFilters}>
                      Discard Changes
                    </button>
                  </div>
                </div>
              </Modal>
              <div className="filter-buttons">
                <button className="clear-all" onClick={clearFilters}>Clear All</button>
                <button className="apply-filter" onClick={applyFilters}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                    <path d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z" fill="white" />
                    <path d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z" fill="white" />
                    <path d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z" fill="white" />
                  </svg>
                  Apply Filters
                </button>
              </div>
            </Modal>
          </div>
        </div>
        <div className="card-outer1">
          <div className="card-outer">
            <div className="card" style={{ opacity: !isLoading && isFetching ? 0.6 : 1, transition: 'opacity 0.2s ease' }}>
              {isLoading === true ? (
                <div className="datatable-in-invoice">
                  <div className="p-datatable p-component p-datatable-responsive-scroll">
                    <div className="p-datatable-wrapper">
                      <table className="p-datatable-table" style={{ minWidth: "50rem", width: "100%", textAlign: "left" }}>
                        <thead className="p-datatable-thead">
                          <tr>
                            <th style={{ paddingRight: "44px" }}>Invoice ID</th>
                            {(user && (user.userCategory !== userCategory.Client)) && (
                              <th style={{ paddingRight: "35px", maxWidth: "230px", minWidth: "230px", width: "230px" }}>Client</th>
                            )}
                            <th style={{ paddingRight: "45px", minWidth: "121.73px" }}></th>
                            <th style={{ paddingRight: "44px" }}>Due Date</th>
                            <th style={{ paddingRight: "44px" }}>Amount</th>
                            <th style={{ paddingRight: "44px" }}>Issue Date</th>
                            <th style={{ paddingRight: "44px", maxWidth: "230px", minWidth: "230px", width: "230px" }}>Created by</th>
                            <th style={{ paddingRight: "44px" }}>Status</th>
                            <th style={{ paddingRight: "44px" }}>Payment Date</th>
                          </tr>
                        </thead>
                        <tbody className="p-datatable-tbody">
                          <ClientInvoiceTableSkeleton rows={rowsPerPage} showClientColumn={user && (user.userCategory !== userCategory.Client)} />
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="datatable-in-invoice">
                  <DataTable
                    value={filteredData}
                    removableSort
                    tableStyle={{
                      minWidth: "50rem",
                      width: "100%",
                      textAlign: "left",
                    }}
                    paginator={totalResults > rowsPerPage}
                    paginatorClassName="recent-invoices-pagination"
                    rows={rowsPerPage} // Set the number of rows per page
                    first={currentPage * rowsPerPage} // Set the current page using currentPage
                    onPage={onPageChange} // Update currentPage when changing pages
                    lazy={true} // Enable lazy loading for server-side pagination
                    totalRecords={totalResults} // Total number of records for pagination
                    emptyMessage={
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2" />
                          <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2" />
                          <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round" />
                          <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No invoices found</p>
                        <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Try adjusting your filters or create a new invoice.</p>
                      </div>
                    }
                  >
                    <Column
                      field="cli_inv_number"
                      header="Invoice ID"
                      className="fixed-sec1"
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column>
                    <Column
                      field="cli_inv_for.client_name"
                      body={useRenderMemberName}
                      header="Client"
                      className="fixed-se11"
                      sortable
                      style={{
                        paddingRight: "35px",
                        maxWidth: "230px",
                        minWidth: "230px",
                        width: "230px",
                        // left: `${sec1}px`,
                      }}
                      sortField="clientName" // Use a different sortField to avoid confusion with the original field
                      sortFunction={(e) => {
                        const dataCopy = [...filteredData];
                        dataCopy.sort((rowData1, rowData2) => {
                          const clientName1 =
                            (rowData1.cli_inv_for?.client_name ||
                              rowData1.cli_inv_for?.legal_entity_name);

                          const clientName2 =
                            (rowData2.cli_inv_for?.client_name ||
                              rowData2.cli_inv_for?.legal_entity_name);

                          // Implement your custom comparison logic here
                          return e.order === 1
                            ? clientName1.localeCompare(clientName2)
                            : clientName2.localeCompare(clientName1);
                        });
                        return dataCopy;
                      }}
                    ></Column>
                    <Column
                      field="_id"
                      body={renderClientsInvoicesCTA}
                      className="fixed-sec21"
                      style={{
                        paddingRight: "45px",
                        minWidth: "121.73px",
                      }}
                    ></Column>
                    <Column
                      field="cli_inv_due_date"
                      body={dateCliInvConvert}
                      header="Due Date"
                      className="fixed-sec31"
                      sortable
                      style={{ paddingRight: "44px", left: `${sec3}px` }}
                    ></Column>
                    <Column
                      field="cli_inv_total_amount"
                      header="Amount"
                      body={renderAmount}
                      className="amount-bold"
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column>
                    <Column
                      field="cli_inv_issue_date"
                      body={createDateCliInvConvert}
                      header="Issue Date"
                      className="fixed-sec31"
                      sortable
                      style={{ paddingRight: "44px", left: `${sec3}px` }}
                    ></Column>
                    <Column
                      field="cli_inv_created_by"
                      body={(rowData) => (
                        <MemberName userId={rowData.cli_inv_created_by} />
                      )}
                      header="Created by"
                      // sortable
                      style={{
                        paddingRight: "44px",
                        maxWidth: "230px",
                        minWidth: "230px",
                        width: "230px",
                      }}
                    ></Column>
                    <Column
                      field="cli_inv_status"
                      header="Status"
                      className="fixed-sec41"
                      body={renderStatus}
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column>
                    <Column
                      field="cli_inv_paid_date"
                      header="Payment Date"
                      body={renderPaymentStatus}
                      sortable
                      style={{ paddingRight: "44px" }}
                    ></Column>
                  </DataTable>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ClientsInvoices;